import { render, staticRenderFns } from "./KendaraanRescueLaporanPage.vue?vue&type=template&id=51f44a98"
import script from "./KendaraanRescueLaporanPage.vue?vue&type=script&lang=js"
export * from "./KendaraanRescueLaporanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports